<script setup>
import "@/styles/css/seo-calculators.scss";
import "rangeslider.js/dist/rangeslider.css";
import "rangeslider.js";

import { onMounted, ref } from "vue";
onMounted(() => {
  require("../../assets/js/nps.js");
});
const view = ref(false);
</script>
<template>
  <main class="seo-calculators nav-seo npm-seo">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>NPS Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->
    <div class="container">
      <h1 class="page-heading">NPS Calculator</h1>
      <h2 class="page-sub-heading">Calculate your national pension scheme.</h2>
      <div class="container no-padding-web">
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="slider-container">
              <form name="calculator">
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">
                      Amount of Monthly Investment
                    </h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="totalInvestments"
                        value="2000"
                        min="1000"
                        max="1000000"
                        step="10"
                        id="total-investment-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="2000"
                    min="1000"
                    max="1000000"
                    step="10"
                    id="total-investment-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />

                  <div class="slider__row">
                    <div class="slider__min">₹1000</div>
                    <div class="slider__max">₹1,000,000.00</div>
                  </div>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Expected Return</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="returnRate"
                        value="10"
                        step="0.1"
                        min="0"
                        max="40"
                        id="return-rate-input"
                      /><span>%</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="0"
                    value="10"
                    step="0.1"
                    max="40"
                    id="return-rate-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">0 %</div>
                    <div class="slider__max">40%</div>
                  </div>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Customer Age</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="timePeriod"
                        value="35"
                        step="1"
                        min="18"
                        max="55"
                        data-current-value=""
                        id="period-input"
                      /><span class="m-l-4">yrs</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="35"
                    step="1"
                    min="18"
                    max="55"
                    id="period-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">18 yrs</div>
                    <div class="slider__max">55 yrs</div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-6 no-padding" id="fix-cash">
            <aside class="calculator-output nps-sidebar">
              <h3 class="calculator-output__heading">Total Investment Value</h3>
              <div
                id="total-investment"
                class="calculator-output__amount--large"
              >
                ₹ 14,34,90,000
              </div>
              <div class="calculator-output__row">
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Interest Earned</h3>
                  <div
                    id="total-interest"
                    class="calculator-output__amount--small"
                  >
                    ₹ 49,11,34,417
                  </div>
                </div>
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Maturity Amount</h3>
                  <div
                    id="total-maturity"
                    class="calculator-output__amount--small"
                  >
                    ₹ 63,46,24,417
                  </div>
                </div>
              </div>
              <div class="calculator-output__row center">
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">
                    Minimum Annuity Investment
                  </h3>
                  <div
                    id="total-min-annuity"
                    class="calculator-output__amount--small"
                  >
                    ₹ 25,38,49,767
                  </div>
                </div>
              </div>
              <div
                class="calculator-output__chart-containerd"
                style="display: none"
              >
                <canvas id="mfChart" width="200"></canvas>
                <div class="calculator-output__chart-container--legend"></div>
              </div>
              <a href="https://wa.me/+917092362098" class="cta"
                >Invest Now</a
              >
            </aside>
          </div>
          <div class="col-md-6 no-padding" id="var-cash" style="display: none">
            <aside class="calculator-output nps-sidebar">
              <h3 class="calculator-output__heading">
                Present Value Of Cash Inflows (PVIFA)
              </h3>
              <div
                id="ainvested-amount"
                class="calculator-output__amount--large"
              ></div>
              <div class="calculator-output__row">
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">
                    Net Present Value (nps)
                  </h3>
                  <div
                    id="atotal-investment"
                    class="calculator-output__amount--small"
                  ></div>
                </div>
              </div>
              <div
                class="calculator-output__chart-containerd"
                style="display: none"
              >
                <canvas id="mfChart" width="200"></canvas>
                <div class="calculator-output__chart-container--legend"></div>
              </div>
              <a href="https://wa.me/+917092362098" class="cta"
                >Invest Now</a
              >
            </aside>
          </div>
        </div>
      </div>
    </div>

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>National Pension Scheme (NPS) Calculator</h2>
      <p></p>
      <p>Let us understand how an NPS calculator can be of great help:</p>
      <p>
        An NPS calculator simplifies the whole process and provides simple
        answers to investors. It requires three key inputs – the amount of money
        to be invested per month, expected rate of return (%) per annum and age
        of a user. Based on these inputs the calculator gives you these outputs
        — the total amount invested, returns earned, maturity amount and minimum
        annuity investment amount.
      </p>
      <p>
        An NPS calculator, thus, offers a glimpse of the future to a user.
        However, there are a few points one should keep in mind while using an
        NPS calculator. The expected return is not assured. The actual return
        may vary. Monthly investment installment may change as the income of the
        NPS subscriber changes. There may be temporary phases of low savings and
        an investor may not invest for a few months. Accordingly, the outcome or
        the accumulated corpus also changes.
      </p>
      <p></p>
    </section>

    <!-- Calculator Faqs Section-->

    <section class="container calculator_help_section">
      <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse1"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Who can open an NPS account?</span>
                </span>
              </h3>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  All Indian citizens, including non-resident Indians, are
                  allowed to open NPS. An NPS account is focused on only one
                  goal – building a retirement corpus for the subscriber. Anyone
                  who is keen to save for his golden years can consider opening
                  an NPS account. Individuals who do not have access to any
                  other social security net – self-employed individuals—should
                  especially open an NPS account. Also, individuals looking for
                  regular income post-retirement may find NPS attractive.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse2"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Where can I open an NPS account?</span>
                </span>
              </h3>
            </div>
            <div id="collapse2" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  Pension Fund Regulatory Development Authority (PFRDA) has
                  ensured that NPS can be opened online. Individuals comfortable
                  transacting online can go for the online process as it offers
                  the comfort of transacting from home. One needs a PAN card,
                  AADHAR card and bank account—all linked—to open an NPS account
                  online and generate a PRAN (Permanent Retirement Account
                  Number).
                </p>
                <p class="visible">
                  In the offline world, there are a few banks and financial
                  institutions that are allowed to act as intermediaries –
                  technically known as points of presence (POP). Visiting one
                  such POP can be of great help. By completing the form and
                  submitting the Know Your Client (KYC) documents a subscriber
                  can open an account offline as well.
                </p>
                <p class="visible">
                  There are two types of NPS accounts – Tier I and Tier II.
                  While the former is the default account, the latter is a
                  voluntary one. Tier I account is meant for retirement planning
                  and withdrawals are not permitted before the age of
                  superannuation except in specified circumstances. Tier II
                  account is like any other investment avenue and offers interim
                  liquidity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse3"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How does an NPS make money?</span>
                </span>
              </h3>
            </div>
            <div id="collapse3" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  Pension Fund Regulatory Development Authority (PFRDA) has
                  appointed pension fund managers for investing money of NPS
                  subscribers. These fund managers invest in stocks, corporate
                  bonds, government securities and select alternate assets. A
                  contributor can select auto choice or decide on their asset
                  allocation. Depending on what a subscriber chooses, the money
                  is allocated between stocks, corporate bonds and government
                  securities. The contributor to the NPS has the right to select
                  the pension fund manager. They can also change the pension
                  fund manager by visiting the POP or by accessing their account
                  online.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse4"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are the tax benefits?</span>
                </span>
              </h3>
            </div>
            <div id="collapse4" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  The contribution of upto ₹50,000 to NPS allows one to claim
                  additional tax deduction under section 80 CCD(1B). This is
                  over and above the tax deduction available for all tax saving
                  options under section 80C. The employer’s contribution to the
                  NPS account is tax-free up to 10% of salary subject to an
                  annual overall ceiling of ₹7.50 lakh for the sum of NPS,
                  employees’ provident fund and superannuation contribution made
                  by the employer. Even if the employer doesn’t offer the option
                  of NPS, you can still open an NPS account and claim deduction
                  for the contribution made to your NPS account.
                </p>
                <p class="visible">
                  At the time of superannuation, 60% of the accumulated money
                  can be withdrawn tax-free. The rest of the money must be used
                  for purchasing an immediate annuity. The annuity received is
                  taxable in the hands of the pensioner as per the slab rate.
                </p>
                <p class="visible">
                  When the money is in the accumulation stage, there is no tax
                  incidence for the contributor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse5"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How much money can I contribute?</span>
                </span>
              </h3>
            </div>
            <div id="collapse5" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  There is no limit on the amount of money you can contribute to
                  tier I and tier II accounts. For both these accounts, minimum
                  investment is pegged at ₹500 and ₹250, respectively. In a tier
                  I account, a minimum of one deposit a year is mandatory.
                  Yearly, the minimum contribution must be kept at ₹1,000 for
                  tier I account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse6"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Is NPS better than mutual funds?</span>
                </span>
              </h3>
            </div>
            <div id="collapse6" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  NPS is meant for retirement planning. Mutual funds on the
                  other hand can be used for funding any financial goal
                  including retirement. Barring ELSS (equity-linked saving
                  schemes), other schemes do not offer any tax breaks. ELSS
                  offers tax breaks for investments up to ₹1.5 lakh per
                  financial year, along with other avenues such as life
                  insurance, EPF, PPF and others.
                </p>
                <p class="visible">
                  When an investor rebalances her asset allocation by selling
                  and buying units of mutual fund schemes focusing on stocks,
                  bonds or gold, there is a tax incidence for the investor. When
                  an investor changes his allocation under NPS, there is no tax
                  incidence for the investor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button
            class="similar-btn btn-all"
            v-if="!view"
            @click="view = !view"
          >
            View all
          </button>
          <button
            class="similar-btn btn-less"
            v-if="view"
            @click="view = !view"
          >
            View less
          </button>
        </div>
        <div class="smooth-wrap" :class="[view ? 'smooth-wrap2' : '']">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Option Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> PPF Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Gratuity calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> HRA Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>

    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
